import Header from '../../components/Header/Header';
import styles from './EventDetail.module.scss';
import arrow from '../../assets/rightArrow.png';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axiosClient from '../../libs/axiosClient';
import { useQuery } from 'react-query';
import qs from 'qs';
import { loginConfirm } from '../../common/loginConfirm';
interface IEventDetailType {
  b_content: string;
  b_edate: string;
  b_img1: string;
  b_sdate: string;
  b_title: string;
  b_uid: number;
}
function EventDetail() {
  const navigate = useNavigate();
  const { eventId } = useParams();
  const { data: event } = useQuery<IEventDetailType>(
    ['event', eventId],
    () =>
      axiosClient.get(`/data/event/detail?event_id=${eventId}`).then((res) => {
        if (!Object.keys(res.data.data).length) return undefined;
        else return res.data.data;
      }),
    {
      staleTime: 60000 * 60 * 24, //1일 캐싱
    },
  );

  return (
    <>
      <Header />
      <main className={styles.container}>
        <header>
          <div className={styles.backBtn} onClick={() => navigate(-1)}>
            <img src={arrow} alt="뒤로가기" />
          </div>
          <h4>EVENT</h4>
        </header>
        {event && (
          <>
            <h2 className={styles.eventTitle}>
              {(() => {
                let isProgressing = false;
                let date = new Date().getTime();
                let startDate = new Date(event.b_sdate).getTime();
                let endDate = new Date(event.b_edate).getTime();
                if (startDate < date && date < endDate) isProgressing = true;
                return (
                  <div
                    className={`${styles.isProgressing} ${
                      !isProgressing ? styles.isOff : ''
                    }`}
                  >
                    {isProgressing ? 'Ongoing' : 'Ended'}
                  </div>
                );
              })()}
              <span>{event.b_title}</span>
            </h2>
            <div className={styles.eventInfo}>
              <span>ONDOC</span>
              <span>{event.b_sdate.replace(/-/g, '.')}</span>
            </div>
            <div
              className={styles.contentWrap}
              dangerouslySetInnerHTML={{
                __html: event.b_content.replace(/\\/g, ''),
              }}
            ></div>
          </>
        )}
      </main>
    </>
  );
}
export default EventDetail;
